import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchCaptableAction } from 'routes/Captable/modules/actions';
import WaterfallComponents from '../components';

const mapStateToProps = state => ({
  literals: state.i18n.literals.captable,
  literalsCommon: state.i18n.literals.common,
  currency: state.global.currency,
  captable: state.captable,
  startup: state.global.startup,
});

const mapDispatchToProps = dispatch => ({
  fetchCaptable: bindActionCreators(fetchCaptableAction, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(WaterfallComponents);
